import { createContext } from 'react';

export interface DeveloperModeContextValue {
  isDeveloperMode: boolean;
  toggleDeveloperMode: () => void;
  ready: boolean;
}

export const DeveloperModeContext = createContext<DeveloperModeContextValue>({
  isDeveloperMode: false,
  toggleDeveloperMode: () => {},
  ready: false,
});
